import { ROLES, type Role } from '../constants/roles';
import type { PlatformConfig } from '../models/PlatformConfig';
import { isOAuthProviderEnabled } from '../models/PlatformConfig';

export const STAFF_GOOGLE_ONBOARDING_ROLES: Role[] = [
  ROLES.BANKER,
  ROLES.LISTER,
  ROLES.RUNNER,
  ROLES.SUPPORT_AGENT,
];

export interface StaffGoogleOnboardingProfile {
  googleSignInRecommended?: boolean;
  googleLinked?: boolean;
  googleLinkPromptDismissed?: boolean;
}

export interface StaffGoogleOnboardingInput {
  role: string;
  firebaseAuth: boolean;
  platformConfig: PlatformConfig;
  profile: StaffGoogleOnboardingProfile | null;
}

export function shouldOfferStaffGoogleLink(input: StaffGoogleOnboardingInput): boolean {
  if (!input.firebaseAuth) return false;
  if (!STAFF_GOOGLE_ONBOARDING_ROLES.includes(input.role as Role)) return false;
  if (!input.platformConfig.staffGoogleLinkOnboarding) return false;
  if (!isOAuthProviderEnabled(input.platformConfig, 'google')) return false;
  if (!input.profile) return false;
  if (input.profile.googleSignInRecommended !== true) return false;
  if (input.profile.googleLinked === true) return false;
  if (input.profile.googleLinkPromptDismissed === true) return false;
  return true;
}
